import { startOfDay } from 'date-fns/startOfDay';
import { addDays } from 'date-fns/addDays';
import { isAfter } from 'date-fns/isAfter';
import { isBefore } from 'date-fns/isBefore';
import { isEqual } from 'date-fns/isEqual';
import { format } from 'date-fns/format';
import { parse } from 'date-fns/parse';
import { PRICELINE_DATE_FORMAT } from '../../constants/dates';
/** @public */
function validateHoverDate(hoveredDate, diff, maxSelectableDate, minSelectableDate) {
  if (diff === 0) {
    return hoveredDate;
  }
  var startOfToday = startOfDay(Date.now());
  var parsedMinSelectableDate = minSelectableDate && parse(minSelectableDate.toString(), PRICELINE_DATE_FORMAT, new Date());
  var minStartDate = parsedMinSelectableDate && isBefore(startOfToday, parsedMinSelectableDate) ? parsedMinSelectableDate : startOfToday;
  var newSelection = addDays(startOfDay(parse(hoveredDate.toString(), PRICELINE_DATE_FORMAT, new Date())), diff);
  var startOfMaxDate = startOfDay(parse(maxSelectableDate.toString(), PRICELINE_DATE_FORMAT, new Date()));
  if (diff && (isAfter(newSelection, minStartDate) || isEqual(newSelection, minStartDate)) && isBefore(newSelection, startOfMaxDate)) {
    return format(newSelection, PRICELINE_DATE_FORMAT);
  }
  return null;
}
export default validateHoverDate;